export default {
  upload: {
    title: 'Опустите ваши .png or .jpg файлы сюда',
    another: 'Другой файл'
  },
  local_db: {
    title: 'Локальная база данных'
  },
  chart: {
    doughnut: {
      title: 'Круговая диаграмма'
    },
    timeseries: {
      title: 'Временной интервал'
    }
  }
}
